/* Belfa: restyle the Shopify Inbox launcher ("Sohbet") + chat panel to the
   datasheet language. The widget renders inside an OPEN shadow root
   (<inbox-online-store-chat>), out of reach of theme CSS — so we inject a
   <style> into the shadow root. Belfa tokens (--ink, --mono, --r, …) inherit
   into shadow trees from belfa-tokens.css; fallbacks mirror their values.
   If Shopify renames the internals this no-ops and the widget keeps its
   default look. */
(function () {
  var STYLE_ID = 'belfa-inbox-style';
  var CSS = [
    /* launcher */
    'button.chat-toggle{',
    '  background-color:var(--ink,#16181a) !important;',
    '  border:var(--hair,1px) solid rgba(255,255,255,.25) !important;',
    '  border-radius:var(--r,2px) !important;',
    '  box-shadow:none !important;',
    '  transition:background-color .12s ease;',
    '}',
    'button.chat-toggle:hover{background-color:#000 !important;}',
    'button.chat-toggle.chat-toggle--text-button{',
    '  height:44px;',
    '  padding:0 14px 0 10px;',
    '  color:var(--paper,#f7f6f2);',
    '  font-family:var(--mono,ui-monospace,monospace);',
    '}',
    'button.chat-toggle.chat-toggle--text-button.text-only{height:44px;padding:0 14px;}',
    'button.chat-toggle .chat-title{',
    /* !important: the widget ships per-:lang() font-size rules (incl. tr)
       that outspecify any sane selector here */
    '  font-size:11px !important;',
    '  font-weight:600;',
    '  letter-spacing:.14em;',
    '  text-transform:uppercase;',
    '  margin:0 0 0 8px;',
    '}',
    'button.chat-toggle.chat-toggle--text-button.text-only .chat-title{margin:0;}',
    'button.chat-toggle svg{height:20px;width:auto;}',
    'button.chat-toggle.chat-toggle--icon-button.icon-only,',
    'button.chat-toggle.chat-toggle--icon-button.mobile-only{height:44px;width:44px;align-items:center;justify-content:center;}',
    'button.chat-toggle.chat-toggle--icon-button.icon-only svg,',
    'button.chat-toggle.chat-toggle--icon-button.mobile-only svg{height:24px;}',
    /* unread badge */
    '.chat-notification{',
    '  background:var(--acc,#a3571f) !important;',
    '  border-radius:var(--r,2px);',
    '  font-family:var(--mono,ui-monospace,monospace);',
    '  font-weight:600;',
    '}',
    /* close (X) button shown while the chat is open */
    '.chat-app--close-button{',
    '  background-color:var(--ink,#16181a) !important;',
    '  border:var(--hair,1px) solid rgba(255,255,255,.25) !important;',
    '  border-radius:var(--r,2px) !important;',
    '  box-shadow:none !important;',
    '}',
    '.chat-app .chat-app--close-button{height:44px;width:44px;font-size:20px;}',
    /* panel — light touch: square corners, hairline instead of shadow, Plex */
    '.chat-ui,.interstitial-view,.chat-header{',
    "  font-family:var(--sans,'IBM Plex Sans',system-ui,sans-serif);",
    '}',
    '.chat-ui:not(.chat-ui--is-mobile){',
    '  border-radius:var(--r-lg,4px);',
    '  box-shadow:0 0 0 var(--hair,1px) var(--line2,#cbc9c1);',
    '}',
    '.chat-header{background-color:var(--ink,#16181a) !important;}',
    '.chat-header:not(.chat-header--is-mobile){',
    '  border-top-left-radius:var(--r-lg,4px);',
    '  border-top-right-radius:var(--r-lg,4px);',
    '}',
    '.interstitial-view:not(.is-mobile){border-radius:var(--r-lg,4px);}',
    /* greeting card: warm ink instead of the raw setting color — the inline
       #000 sits on the inner .store-info, not the wrapper */
    '.interstitial-view__welcome{background-color:var(--ink,#16181a) !important;}',
    '.interstitial-view__welcome .store-info{background-color:var(--ink,#16181a) !important;}',
    '.interstitial-view__instant-answers-list{border-radius:0 0 var(--r-lg,4px) var(--r-lg,4px);}',
  ].join('\n');

  /* PDP mobile: sections/belfa-sticky-buy.liquid fixes a ~61px bar (+ safe
     area) to the bottom edge; at the widget's "lowest" position the launcher
     lands on the bar's Sepete ekle button. Lift it clear (61 + 8px gap).
     transform (not bottom) so we never fight the widget's own positioning;
     the host element must NOT be transformed — it would become the containing
     block for the widget's fixed-position internals. */
  var OFFSET_STYLE_ID = 'belfa-inbox-sticky-offset';
  var OFFSET_CSS = [
    '@media (max-width: 749px){',
    '  button.chat-toggle{',
    '    transform:translateY(calc(-69px - env(safe-area-inset-bottom, 0px))) !important;',
    '  }',
    '}',
  ].join('\n');

  function tryInject() {
    var host = document.querySelector('inbox-online-store-chat');
    if (!host || !host.shadowRoot) return false;
    if (!host.shadowRoot.getElementById(STYLE_ID)) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      host.shadowRoot.appendChild(style);
    }
    if (document.querySelector('[data-belfa-sticky]') && !host.shadowRoot.getElementById(OFFSET_STYLE_ID)) {
      var offset = document.createElement('style');
      offset.id = OFFSET_STYLE_ID;
      offset.textContent = OFFSET_CSS;
      host.shadowRoot.appendChild(offset);
    }
    return true;
  }

  tryInject();

  /* Stay subscribed instead of disconnecting on first success: the widget can
     (re)mount its element after load, which would drop an injected style.
     tryInject is idempotent and cheap, so re-checking per mutation batch is fine. */
  new MutationObserver(tryInject).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('inbox-online-store-chat').then(function () {
      setTimeout(tryInject, 0);
    });
  }
})();
